import React from "react";
import { Coming } from "../../../components/Coming/Coming";

const Repayment = () => {
  return (
    <div>
      <Coming />
    </div>
  );
};

export default Repayment;
